<template>
  <div class="top">
    <div><span>━</span> &nbsp;青海专业技术人员学习网&nbsp; <span>━</span></div>
    <img src="../assets/bg-top.png"
         alt="" />
  </div>

</template>
<script>
export default {
  name: "HelloWorld",
  data () {
    return {}
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.top {
  height: 58px;
  /*line-height: 64px;*/
  text-align: center;
  width: 100%;
  margin: 0 auto;
  color: #fff;
  display: flex;
  flex-wrap: nowrap;
}
.top div {
  font-size: 24px;
  position: absolute;
  top: 2.8%;
  left: 42%;
  font-weight: bold;
  background-image: -webkit-linear-gradient(top,#e4fafd,#c6afff);
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
  height: 25px;
  line-height: 25px;
}
.top div > span{
  font-weight: bold;
  font-size: 16px;
  color: #FFFFFF;
}

.top img {
  width: 100%;
  position: absolute;
  top: -1%;
  left: 50%;
  transform: translateX(-50%);
}
</style> 
